import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setAuthToken } from "@/lib/apiClient";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [underConstruction, setUnderConstruction] = useState(false);
  const [settingsLoading, setSettingsLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const loadSettings = useCallback(async () => {
    try {
      const res = await api.get("/settings/public");
      setUnderConstruction(!!res.data.under_construction);
    } catch (e) {
      setUnderConstruction(false);
    } finally {
      setSettingsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadSettings();
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth, loadSettings]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setAuthToken(null);
    setUser(null);
    window.location.href = "/";
  };

  const isPrivileged = user && ["admin", "super_admin"].includes(user.role);

  return (
    <AuthContext.Provider value={{ user, setUser, loading, checkAuth, logout, isPrivileged,
      underConstruction, setUnderConstruction, settingsLoading, refreshSettings: loadSettings }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
